import React from 'react';

const Plus = () => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 21">
        <path
            fill="currentColor"
            fillRule="nonzero"
            stroke="currentColor"
            strokeWidth="2"
            d="M2.188 9.313h7.124V2.186a1.188 1.188 0 0 1 2.376 0v7.126h7.124a1.188 1.188 0 0 1 0 2.374h-7.125v7.126a1.188 1.188 0 0 1-2.374 0v-7.125H2.186a1.188 1.188 0 0 1 0-2.376Z"
        />
    </svg>
);

export default Plus;
